









































































import { Component, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { OrganizationsRepository } from '@/repository/repositories/theoryApi/organizations.repository';
import { vxm } from '@/store';

@Component({
  components: {
    CommonButton,
  },
})
export default class CreateOrganization extends Vue {
  private organizationRepository: OrganizationsRepository = RepositoryFactory.theoryApi.organizationsRepository();
  private createOrganizationDto = {
    accountId: this.accountId,
    organizationName: '',
    prefectureCd: null,
    cityCd: null,
    organizationStreetAddress: null,
    organizationPhoneNumber: null,
    organizationEmail: null,
    organizationPerson: null,
    sectorCd: null,
    organizationComment: null,
    organizationIcon: null,
    billingPlan: '',
  };
  private readonly billingPlans = [
    'free',
    'standard',
    'business',
    'enterprise',
    'enterprise_premium',
  ];

  private get accountId() {
    const response = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (response) {
      return response.results.accountId;
    } else return null;
  }

  private async createOrganization() {
    const createOrganization = await this.organizationRepository.createOrganization(
      this.createOrganizationDto
    );
    if (createOrganization) {
      vxm.theoryApi.authStore.fetchCurrentOrganizationId(
        createOrganization.organizationId
      );
      await vxm.theoryApi.accountsStore.fetchAccountParticipationOrganizations(
        this.accountId as number
      );
      const organizations =
        vxm.theoryApi.accountsStore.getAccountParticipationOrganizations;
      if (organizations) {
        const organization = organizations.results.find((organization) => {
          return (
            organization.organizationId === createOrganization.organizationId
          );
        });
        if (organization) {
          vxm.theoryApi.authStore.fetchCurrentOrganizationName(
            organization.organizationName
          );
        }
      }
    }
    this.$router.push({ name: 'createProject' });
  }
}
